import React from 'react';
export const CartIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-140">
    <path d="M6 8H18L19 20H5L6 8Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-141" />
    <path d="M9 8V6C9 4.34315 10.3431 3 12 3C13.6569 3 15 4.34315 15 6V8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-142" />
    <path d="M12 11C12 11 10 10 10 8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-143" />
    <path d="M12 11C12 11 14 10 14 8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-144" />
  </svg>;
export const SearchIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-145">
    <circle cx="11" cy="11" r="6" stroke="currentColor" strokeWidth="1.25" data-id="element-146" />
    <path d="M16 16L21 21" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-147" />
    <path d="M18.5 18.5L19.5 17.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-148" />
  </svg>;
export const UserIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-149">
    <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.25" data-id="element-150" />
    <path d="M6 21C6 17.6863 8.68629 15 12 15C15.3137 15 18 17.6863 18 21" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-151" />
  </svg>;
export const WhatsAppIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-152">
    <path d="M21 11.5C21 16.1944 17.1944 20 12.5 20C10.8878 20 9.37962 19.5516 8.10657 18.7758L4 20L5.2242 15.8934C4.44841 14.6204 4 13.1122 4 11.5C4 6.80558 7.80558 3 12.5 3C17.1944 3 21 6.80558 21 11.5Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-153" />
    <path d="M9.5 9.5C9.5 9.5 10 9 10.5 9C10.7761 9 11 9.22386 11 9.5C11 10 11.5 11 11.5 11.5C11.5 11.7761 11.2761 12 11 12C10.5 12 10.5 13 11 13.5C11.5 14 12.5 14 13 13.5C13.2761 13 13.5 12.7761 13.5 12.5C13.5 12 14.5 12.5 15 13C15.2761 13.2761 15.5 13.5 15.5 14C15.5 14.5 15 15 15 15C14.5 15 13.5 15 12 14C10.5 13 9.5 11.5 9.5 10.5C9.5 10 9.5 9.5 9.5 9.5Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-154" />
  </svg>;
export const ShippingIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-155">
    <rect x="4" y="10" width="16" height="11" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-156" />
    <rect x="3" y="6" width="18" height="4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-157" />
    <path d="M12 6V21" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-158" />
    <path d="M12 6C12 6 10 3 8 3C6 3 6 5 8 6C10 7 12 6 12 6Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-159" />
    <path d="M12 6C12 6 14 3 16 3C18 3 18 5 16 6C14 7 12 6 12 6Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-160" />
  </svg>;
export const SecurityIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-161">
    <path d="M12 6L9 11H15L12 6Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-162" />
    <path d="M7 11L4 6L5 13" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-163" />
    <path d="M17 11L20 6L19 13" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-164" />
    <path d="M5 13H19" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-165" />
    <path d="M6 13L7 18H17L18 13" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-166" />
  </svg>;
export const CrownStarIcon = ({
  className = 'w-4 h-4'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-167">
    <path d="M12 5L9 11H15L12 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-168" />
    <path d="M6 11L3 5L5 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-169" />
    <path d="M18 11L21 5L19 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-170" />
    <path d="M5 14H19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-171" />
    <path d="M6 14L7 19H17L18 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-172" />
  </svg>;
export const HamburgerIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-173">
    <path d="M4 6H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-174" />
    <path d="M4 12H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-175" />
    <path d="M4 18H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-176" />
  </svg>;
export const CloseIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-177">
    <path d="M6 6L18 18" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-178" />
    <path d="M18 6L6 18" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-179" />
  </svg>;
export const ChevronIcon = ({
  className = 'w-6 h-6',
  direction = 'right'
}: {
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right';
}) => {
  const rotation = {
    up: 'rotate-[-90deg]',
    down: 'rotate-90',
    left: 'rotate-180',
    right: 'rotate-0'
  }[direction];
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className} ${rotation} transition-transform`} data-id="element-180">
      <path d="M9 6L15 12L9 18" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-181" />
    </svg>;
};
export const PlusIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-182">
    <path d="M12 5V19" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-183" />
    <path d="M5 12H19" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-184" />
  </svg>;
export const MinusIcon = ({
  className = 'w-6 h-6'
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-185">
    <path d="M5 12H19" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-186" />
  </svg>;
// Category Icons
export const WomenShapewearIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-187">
    <path d="M10 6C10 6 12 12 12 16C12 20 10 26 10 26" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-188" />
    <path d="M22 6C22 6 20 12 20 16C20 20 22 26 22 26" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-189" />
    <path d="M10 6H22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-190" />
    <path d="M10 26H14V22H18V26H22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-191" />
    <path d="M12 6V4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-192" />
    <path d="M20 6V4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-193" />
  </svg>;
export const MenShapewearIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-194">
    <path d="M8 8L12 4H20L24 8V12L22 14V26H10V14L8 12V8Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-195" />
    <path d="M12 4V12" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-196" />
    <path d="M20 4V12" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-197" />
    <path d="M16 14V26" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-198" />
  </svg>;
export const FoamIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-199">
    <rect x="8" y="6" width="16" height="20" rx="4" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-200" />
    <path d="M12 10H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-201" />
    <path d="M12 16H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-202" />
    <path d="M12 22H20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-203" />
  </svg>;
export const BoardIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-204">
    <ellipse cx="16" cy="16" rx="10" ry="12" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-205" />
    <path d="M16 8V24" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeDasharray="2 2" data-id="element-206" />
    <path d="M10 16H22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeDasharray="2 2" data-id="element-207" />
  </svg>;
export const GelIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-208">
    <path d="M12 8H20V12C20 12 22 14 22 18V26H10V18C10 14 12 12 12 12V8Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-209" />
    <path d="M14 4H18V8H14V4Z" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" data-id="element-210" />
    <path d="M16 16V22" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-211" />
    <path d="M14 19H18" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-212" />
  </svg>;
export const BraIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-213">
    <path d="M6 14C6 14 8 20 12 20C16 20 16 16 16 16C16 16 16 20 20 20C24 20 26 14 26 14" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-214" />
    <path d="M12 20V24" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-215" />
    <path d="M20 20V24" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-216" />
    <path d="M8 24H24" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-217" />
    <path d="M10 14V8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-218" />
    <path d="M22 14V8" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-219" />
    <path d="M16 16V24" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-220" />
  </svg>;
export const BeltIcon = ({
  className = 'w-8 h-8'
}: {
  className?: string;
}) => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-221">
    <rect x="4" y="12" width="24" height="8" rx="1" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-222" />
    <rect x="14" y="10" width="4" height="12" rx="1" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-223" />
    <path d="M8 12V20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-224" />
    <path d="M24 12V20" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" data-id="element-225" />
  </svg>;